module.exports = __webpack_public_path__ + "d9e4e66f2642b4e3a3169ad1a86ce705.pdf";